//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'SpirometricValues',
  data() {
    return {
      defaultJson:{
        "Height": "身高",
        "Method": "公式",
        "ERS (Europe)": "ERS（欧洲）",
        "Crapo (USA)": "Crapo（美国）",
        "Predicted FEV₁": "FEV₁ 预测值",
        "Predicted FVC": "FVC 预测值",
        "Age": "年龄"
      },
      form:{
        method:"0",
        a:'',
        h:'',
        gender:'1',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:'0',name:'ERS（欧洲）'},
        {value:'7',name:'Crapo（美国）'},
      ],
      dataList2: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
      activeIndex:0,
      fvc:'--'
      
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.form.method = item.value;
      this.activeIndex = index
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        self.fvc='--'
        return '--'
      } else {
        let result = 0 
        /*  gender.isMale ?
        (method ?
          ((0.0414*h)-(0.0244*a)-2.19) :
          ((0.0430*h) - (0.029*a) - 2.49) 
        ) :
        (method ?
          ((0.0342*h)-(0.0255*a)-1.578) :
          ((0.0395*h) - (0.025*a) - 2.60) 
        ) */
        result = form.gender==1 ? (form.method ? ((0.0414*form.h)-(0.0244*form.a)-2.19) : ((0.0430*form.h) - (0.029*form.a) - 2.49) ) :  (form.method ? ((0.0342*form.h)-(0.0255*form.a)-1.578) : ((0.0395*form.h) - (0.025*form.a) - 2.60) ) 
        let fvc = ''
        /* gender.isMale ?
        (method ?
          ((0.06*h)-(0.0214*a)-4.65) :
          ((0.0576*h) - (0.026*a) - 4.34) 
        ) :
        (method ?
          ((0.0491*h)-(0.0216*a)-3.59) :
          ((0.0443*h) - (0.026*a) - 2.89) 
        ) */


        fvc = form.gender==1 ? (form.method ? ((0.06*form.h)-(0.0214*form.a)-4.65) : ((0.0576*form.h) - (0.026*form.a) - 4.34)) : (form.method ? ((0.0491*form.h)-(0.0216*form.a)-3.59) : ((0.0443*form.h) - (0.026*form.a) - 2.89) )

        self.fvc = String(fvc.toFixed(2))
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/SpirometricValues.vue